<template>
  <div class="match-loading" v-if="isShow">
    <div class="loading-text-wrap">
      <div v-show="showText >= 1" class="loading-text-1" :class="{'finish': finish >= 1}">正在解析简历</div>
      <div v-show="showText >= 2" class="loading-text-2" :class="{'finish': finish >= 2}">正在生成人才画像</div>
      <div v-show="showText >= 3" class="loading-text-3" :class="{'finish': finish >= 3}">正在匹配合适的人选</div>
    </div>
    <div class="new-progress">
      <div class="new-pregress-inner-wrap">
        <div class="new-progress-inner" :class="{'ani-step1': step==1,'ani-step2': step==2,'ani-step3': step==3}"></div>
      </div>
    </div>
    <!-- <div class="loading-text" :class="{'ani-flash': finish < 3}">{{finish < 3?'L o a d i n g ...':'匹配成功'}}</div> -->
    <div class="loading-text ani-flash">L o a d i n g ...</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      showText: 1,
      step: 1,
      finish: 0,
    }
  },
  methods: {
    open() {
      this.showText = 1
      this.step = 1
      this.finish = 0
      this.isShow = true
      setTimeout(() => {
        this.finish = 1
        this.showText = 2
        this.step = 1
      }, 500)
      setTimeout(() => {
        this.finish = 2
        this.showText = 3
        this.step = 2
      }, 1000)
      setTimeout(() => {
        this.step = 3
      }, 1500)
      // setTimeout(() => {
      //   this.finish = 3
      // }, 3000)
    },
    close() {
      this.isShow = false
    }
  }
}
</script>
<style scoped>
.match-loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1050;
}
.loading-text-wrap {
  margin-bottom: 50px;
  height: 180px;
  width: 240px;
}
.loading-text-wrap > div {
  font-size: 26px;
  color: #ccc;
  margin-bottom: 20px;
  position: relative;
}
.loading-text-wrap > div.finish::before {
  content: '√';
  font-weight: 600;
  font-size: 30px;
  color: #67c23a;
  margin-right: 50px;
  position: absolute;
  left: -50px;
  top: 0;
}
.loading-text-wrap > div.finish {
  color: #fff;
}
.loading-text {
  font-size: 24px;
  color: #fff;
  margin-top: 20px;
}
.new-progress {
  width: 50%;
  height: 40px;
  border-radius: 20px;
  border: 2px solid#409eff;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}
.new-pregress-inner-wrap {
  overflow: hidden;
  left: 6px;
  height: 30px;
  top: 3px;
  position: relative;
  border-radius: 15px;
  width: 98%;
}
.new-progress-inner {
  width: 100%;
  height: 30px;
  border-radius: 15px;
  background-color: #409eff;
  position: absolute;
  top: 0;
  left: -100%;
}
.ani-flash {
  animation: flash 1.5s ease-in-out infinite;
  /* color: #999; */
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.ani-step1 {
  animation: step1 0.75s ease-in-out forwards;
}
@keyframes step1 {
  0% {
    left: -100%;
  }
  30% {
    left: -100%;
  }
  50% {
    left: -85%;
  }
  80% {
    left: -75%;
  }
  100% {
    left: -70%;
  }
}
.ani-step2 {
  animation: step2 0.75s ease-in-out forwards;
}
@keyframes step2 {
  0% {
    left: -70%;
  }
  30% {
    left: -65%;
  }
  50% {
    left: -50%;
  }
  80% {
    left: -50%;
  }
  100% {
    left: -30%;
  }
}
.ani-step3 {
  animation: step3 0.75s ease-in-out forwards;
}
@keyframes step3 {
  0% {
    left: -30%;
  }
  30% {
    left: -30%;
  }
  50% {
    left: -10%;
  }
  80% {
    left: -5%;
  }
  100% {
    left: -0%;
  }
}
</style>
